















































import Vue from "vue";
import { required, email } from "vuelidate/lib/validators";

import { AuthLoginForm } from "../forms/AuthLoginForm";

export default Vue.extend({
  validations: {
    authLoginForm: {
      email: { required, email },
      password: { required }
    }
  },
  data() {
    const authLoginForm: AuthLoginForm = {
      email: "",
      password: ""
    };

    const isLoading = false;
    const isShowDialog = false;
    const errorMessage = "";

    return { authLoginForm, isLoading, isShowDialog, errorMessage };
  },

  computed: {
    emailError() {
      return (this as any).$v.authLoginForm.email.$error
        ? "Email is required or invalid"
        : "";
    },
    passwordError() {
      return (this as any).$v.authLoginForm.password.$error
        ? "Password is required"
        : "";
    }
  },
  methods: {
    async login() {
      this.$v.$touch();
      if (this.$v.$invalid) return;

      this.isLoading = true;

      try {
        await (this as any).$dep.authUseCase.login(this.authLoginForm);

        this.$router.push({ name: "PromotionViewPage" });
      } catch (error) {
        if (error.response && error.response.status === 401) {
          this.errorMessage = "อีเมล หรือ รหัสผ่านผิดพลาด";
        } else {
          this.errorMessage = "Error";
        }

        this.isShowDialog = true;
      } finally {
        this.isLoading = false;
      }
    },
    closeDialog() {
      this.isShowDialog = false;
    }
  }
});
